import React, { useState, useEffect, useRef } from "react";
import DataTable from "../DataTable";
import { Link } from "react-router-dom";
import "../../index.css";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import EditInventory from "./EditInventory";
import { gql, useMutation, useQuery } from "@apollo/client";
import Loader from "../../Loader";
import AddInventoryCategory from "./AddInventoryCategory";
import { useAuthz } from "../../auth/useAuthz";

const DELETE_INVENTORY_CATEGORY = gql`
  mutation deleteInventory($data: ID!) {
    deleteInventory(data: $data) {
      status
      message
    }
  }
`;

const GET_INVENTORY_CATEGORY = gql`
  query {
    getInventoryCategory {
      message
      status
      categories {
        id
        name
        abbr
        parts
        minStock
        canDecrease
        isScanRequired
        minStockAdmin
        allowManualCount
        addOncePerBooking
        cost
        extraPrice
        shelfLifeDays
      }
    }
  }
`;

const InventoryCategoryTable = () => {
  const { can } = useAuthz();
  const { loading, error, data } = useQuery(GET_INVENTORY_CATEGORY);
  const [dataList, setDataList] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const [id, setid] = useState("");

  const [deleteInventoryCategory, { loading: prodDeletLoading }] = useMutation(
    DELETE_INVENTORY_CATEGORY
  );

  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    try {
      if (data?.getInventoryCategory?.categories) {
        setDataList(data.getInventoryCategory.categories);
        console.log(data.getInventoryCategory.categories);
        setIsFetched(true);
      }
    } catch (err) {
      console.log(err);
    }
  }, [data]);

  const handleRemoveRow = (dataId) => {
    deleteInventoryCategory({
      variables: { data: dataId },
    }).then((res) => {
      if (res.data.deleteInventoryCategory.status === "SUCCESS") {
        window.location.reload();
      }
    });
  };

  const handleEditClick = (data) => {
    setEditData(data);
    setEditForm(true);
  };

  if (loading || prodDeletLoading || !isFetched) return <Loader />;

  return (
    <>
      {isFetched &&
        (editForm ? (
          <AddInventoryCategory
            editFormData={editData}
            setEditForm={setEditForm}
          />
        ) : (
          <div className="min-h-screen flex">
            <Sidebar />
            <Layout>
              <div className="flex flex-col space-y-6 pt-8 ">
                <div className="flex justify-between items-center">
                  <div className="flex text-[#FBB033] items-center font-be-jost-pro text-xl font-bold space-x-3 pt-8 pl-5">
                    <Link
                      to="/admin/services"
                      className="text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                    >
                      <span> Services</span>
                    </Link>

                    <Link
                      to="/admin/category"
                      className=" text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                    >
                      <span>Category</span>
                    </Link>
                    <Link
                      to="/admin/sub-category"
                      className=" text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                    >
                      <span>Sub Category</span>
                    </Link>
                    <Link
                      to="/admin/inventory-table"
                      className=" text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                    >
                      <span>Inventory</span>
                    </Link>
                    <p className="hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left bg-white text-[#00395E]">
                      Inventory Category
                    </p>
                     <Link
                                                          to="/admin/order-feedback-question-table"
                                                          className=" text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
                                                        >
                                                          <span>Feedback Questions</span>
                                                        </Link>
                  </div>
                  {can("inventoryCategory.create") && (
                    <div>
                      <Link
                        to="/admin/inventory-category/create"
                        className="font-be-jost-pro font-medium text-sm border border-[#FBB033] text-[#FBB033] rounded-md px-5 py-2"
                      >
                        Add Inventory Category
                      </Link>
                    </div>
                  )}
                </div>
                <div>
                  <DataTable tableName="Inventory">
                    <thead>
                      <tr>
                        <th data-priority="1" className="text-white">
                          Name
                        </th>
                        <th data-priority="2" className="text-white">
                          Abbr
                        </th>
                        <th data-priority="3" className="text-white">
                          Min Stock
                        </th>
                        <th data-priority="3" className="text-white">
                          Min Stock Admin
                        </th>
                        <th data-priority="4" className="text-white">
                          Parts
                        </th>
                        <th data-priority="5" className="text-white">
                          can Decrease
                        </th>
                        <th data-priority="5" className="text-white">
                          Scan Required
                        </th>
                        <th data-priority="5" className="text-white">
                          Manual Count
                        </th>
                        <th data-priority="5" className="text-white">
                          Every Booking
                        </th>

                        <th data-priority="6" className="text-white">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataList.map((row) => {
                        return (
                          <tr
                            key={row.id}
                            className="border-b-2 border-b-[#E0E0E0]"
                          >
                            <td className="text-white w-[10%] px-1 border-b-[1px] border-b-[#E0E0E0]">
                              {row.name}
                            </td>
                            <td className="w-[8%] border-b-[1px] border-b-[#E0E0E0]">
                              {row.abbr}
                            </td>
                            <td className="w-[8%] border-b-[1px] border-b-[#E0E0E0]">
                              {row.minStock}
                            </td>
                            <td className="w-[8%] border-b-[1px] border-b-[#E0E0E0]">
                              {row.minStockAdmin}
                            </td>
                            <td className="w-[8%] border-b-[1px] border-b-[#E0E0E0]">
                              {row.parts}
                            </td>
                            <td className="text-white w-[7%] text-center border-b-[1px] border-b-[#E0E0E0]">
                              {row.canDecrease !== null &&
                                (row.canDecrease ? "Yes" : "No")}
                            </td>
                            <td className="text-white w-[7%] text-center border-b-[1px] border-b-[#E0E0E0]">
                              {row.isScanRequired !== null &&
                                (row.isScanRequired ? "Yes" : "No")}
                            </td>
                            <td className="text-white w-[7%] text-center border-b-[1px] border-b-[#E0E0E0]">
                              {row.allowManualCount !== null &&
                                (row.allowManualCount ? "Yes" : "No")}
                            </td>
                            <td className="text-white w-[7%] text-center border-b-[1px] border-b-[#E0E0E0]">
                              {row.addOncePerBooking ? "Yes" : "No"}
                            </td>
                            <td className="w-[10%] text-center px-2 border-b-[1px] border-b-[#E0E0E0]">
                              <div className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 items-center justify-center h-full lg:space-x-2">
                                {can("inventoryCategory.edit") && (
                                  <button
                                    className="rounded-md bg-white py-2 px-3 text-black text-sm font-medium"
                                    onClick={() => handleEditClick(row)}
                                  >
                                    Edit
                                  </button>
                                )}
                                {/* <button
                                  onClick={() => handleRemoveRow(row.id)}
                                  className="rounded-md bg-white py-2 px-3 text-black text-sm font-medium"
                                >
                                  Delete
                                </button> */}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </DataTable>
                </div>
              </div>
            </Layout>
          </div>
        ))}
    </>
  );
};

export default InventoryCategoryTable;
